import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../cn";

/* 1:1 with discordforge.org — StepDetails.tsx inputFieldClass:
 *   "w-full rounded-xl border border-white/10 bg-black/20 px-3.5 py-2.5 text-sm
 *    text-white outline-none transition focus:border-orange-400/60
 *    focus:ring-2 focus:ring-orange-400/15 font-medium"
 */
export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ className, invalid, ...rest }, ref) => (
        <input
            ref={ref}
            className={cn(
                "w-full rounded-xl border bg-black/20 px-3.5 py-2.5 text-sm font-medium text-white outline-none transition",
                "placeholder:text-zinc-500",
                invalid
                    ? "border-red-500/50 focus:border-red-400 focus:ring-2 focus:ring-red-400/15"
                    : "border-white/10 focus:border-orange-400/60 focus:ring-2 focus:ring-orange-400/15",
                "disabled:cursor-not-allowed disabled:opacity-50",
                className
            )}
            {...rest}
        />
    )
);

Input.displayName = "Input";
